import { useConfirm } from '../../hooks/useConfirm/useConfirm';
import { Button, ButtonProps } from '../Button/Button';
import { ConfirmationDialog, ConfirmationDialogProps } from '../ConfirmationDialog/ConfirmationDialog';

type Props = Omit<ButtonProps<'button'>, 'onClick'> &
  Omit<ConfirmationDialogProps, 'handleCancel' | 'handleConfirm' | 'open'> & {
    onConfirm: () => void;
    onCancel?: () => void;
    children: React.ReactNode;
  };

export const ConfirmationButton = ({
  onConfirm,
  onCancel: onReject,
  title,
  message,
  children,
  disableBackdropClose,
  slotProps,
  ...rest
}: Props) => {
  const { open, handleClickOpen, handleCancel, handleConfirm } = useConfirm({ onConfirm, onReject });

  return (
    <>
      <Button onClick={handleClickOpen} {...rest} sx={{ pointerEvents: 'auto' }}>
        {children}
      </Button>
      <ConfirmationDialog
        open={open}
        handleCancel={handleCancel}
        handleConfirm={handleConfirm}
        title={title}
        message={message}
        slotProps={slotProps}
        disableBackdropClose={disableBackdropClose}
      />
    </>
  );
};
